import { dispatch } from "@selkirk-systems/state-management";
import { ADD_ERROR } from "../constants/FetchConstants";
const handler = err => response => options => next => {
  if (err) {
    dispatch(ADD_ERROR, err);
    return;
  }
  return next(null, response);
};

//HANDLE: Not being called from a service worker
if (!self) {
  // NOTE: event name is all lower case as per DOM convention
  window.addEventListener("unhandledrejection", function (e) {
    // NOTE: e.preventDefault() must be manually called to prevent the default
    // action which is currently to log the stack trace to console.warn
    e.preventDefault();
    // NOTE: parameters are properties of the event detail property
    var reason = e.reason || e.detail.reason;
    //var promise = e.detail.promise;
    // See Promise.onPossiblyUnhandledRejection for parameter documentation
    console.groupEnd();
    console.groupEnd();
    console.groupEnd();
    throw reason;
  });

  // NOTE: event name is all lower case as per DOM convention
  window.addEventListener("rejectionhandled", function (e) {
    // NOTE: e.preventDefault() must be manually called prevent the default
    // action which is currently unset (but might be set to something in the future)
    e.preventDefault();
    // NOTE: parameters are properties of the event detail property
    var promise = e.reason || e.detail.promise;
    // See Promise.onUnhandledRejectionHandled for parameter documentation
    console.groupEnd();
    console.log("REJECTION HANDLED", promise);
  });
}
export default handler;